define('services/common/common-utils',['app', 'viewer'], function (app, imgViewer) {
    return app.factory('commonUtils', ['$q', 'auiAgreementHelper',
        function ($q, auiAgreementHelper) {
            /**
             * 日期加减
             */
            function addDate(date, days) {
                var d = new Date(date);
                d.setDate(d.getDate() + days);
                var m = d.getMonth() + 1;
                return d.getFullYear() + '-' + m + '-' + d.getDate();
            }

            /**
             * 两个日期相差天数
             */
            function getDaysBetween(date1, date2) {
                var days = (date2 - date1) / (1 * 24 * 60 * 60 * 1000);
                if (days <= 0) {
                    days = 1;
                }
                return Math.floor(days);
            }

            /**
             * 增加月份
             */
            function addMonth(date, num) {
                num = parseInt(num);
                var sDate = dateToDate(date);
                var sDay = sDate.getDate();
                var sMonth = sDate.getMonth() + 1;
                var sYear = sDate.getFullYear();
                var eDay = sDay;
                var eMonth = sMonth + num;
                var eYear = sYear;
                while (eMonth > 12) {
                    eYear = eYear + 1;
                    eMonth -= 12;
                }
                var eDate = new Date(eYear, eMonth - 1, eDay);

                while (eDate.getMonth() != eMonth - 1) {
                    eDay = eDay - 1;
                    eDate = new Date(eYear, eMonth - 1, eDay);
                }

                return eDate;
            }

            function dateToDate(date) {
                var dateT = new Date();
                if (typeof date == "object") {
                    dateT = date;
                } else if (typeof date == "string") {
                    var tip = "-";
                    var arrNew = date.split(tip)
                    if (arrNew.length == 3) {
                        dateT = new Date(arrNew[0] + tip + arrNew[1] + tip + arrNew[2]);
                    }
                }
                return dateT;
            }

            /**
             * 图片预览功能
             */
            function picExtend(id1, id2, id3) {
                setTimeout(function () {
                    var options = {
                        url: function (image){
                            return image.currentSrc;
                        },
                        title: false,
                        backdrop: false,
                        toolbar: false,
                        className: "modal"
                    };
                    if (id1) {
                        if (document.getElementById(id1)) {
                            var pictures1 = document.getElementById(id1);
                            new imgViewer(pictures1, options);
                        }
                    }
                    if (id2) {
                        if (document.getElementById(id2)) {
                            var pictures2 = document.getElementById(id2);
                            new imgViewer(pictures2, options);
                        }
                    }
                    if (id3) {
                        if (document.getElementById(id3)) {
                            var pictures3 = document.getElementById(id3);
                            new imgViewer(pictures3, options);
                        }
                    }
                }, 1200);
            }

            function showAgreement(agreeArr) {
                var defer = $q.defer();
                auiAgreementHelper.viewAndDownloadAgreements(agreeArr).then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //截取字符串
            function handleStrLength(str, length) {
                if (str && str.length > length) {
                    return str.substr(0, length) + '...';
                } else {
                    return str;
                }
            }

            function validateIDNumber() {
                return {
                    test: function (value) {
                        if (value) {
                            return AUI.BaseJSUtil.isIdCard(value);
                        } else {
                            return true;
                        }
                    }
                };
            }

            //替换原始的域名
            function replaceOriginalDomain(originalUrl) {
                //约定originalDomainSwitchObject 里面的对象不能自己再替换回去
                if (originalUrl && sysUrlCfg.originalDomainSwitchObject && Object.keys(sysUrlCfg.originalDomainSwitchObject).length > 0) {
                    Object.keys(sysUrlCfg.originalDomainSwitchObject).forEach(function (key) {
                        if (originalUrl.indexOf(key) > -1) {
                            originalUrl = originalUrl.replace(new RegExp(key, "g"), sysUrlCfg.originalDomainSwitchObject.key)
                        }
                    })

                }
                return originalUrl;
            }

            return {
                addDate: addDate,
                getDaysBetween: getDaysBetween,
                addMonth: addMonth,
                picExtend: picExtend,
                showAgreement: showAgreement,
                handleStrLength: handleStrLength,
                validateIDNumber: validateIDNumber,//校验身份证号
                replaceOriginalDomain: replaceOriginalDomain
            }
        }]);
});


